var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecSheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.845,
    height: 53.768,
    viewBox: "0 0 63.845 53.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_30",
    "data-name": 30,
    transform: "translate(-735.721 -171.792)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(736.208 188.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M783.7,305.936l12.06,6.962a2.347,2.347,0,0,0,2.386.234l-28.026,16.294a2.374,2.374,0,0,1-2.386-.234l-29.278-16.914L766.485,296l10.949,6.321",
    transform: "translate(-738.459 -295.996)",
    fill: "#1a3173"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(754.118 198.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(15.782)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    y1: 3.089,
    x2: 5.317,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(0 5.071)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    y1: 7.187,
    x2: 12.371,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(3.665 4.778)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    y1: 9.609,
    x2: 16.54,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(7.33 9.555)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    y1: 6.961,
    x2: 11.982,
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(769.492 200.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M955.294,366.414l-.012,3.9c-.012,1.837-.655,3.135-1.708,3.743l-28.026,16.294a4.1,4.1,0,0,0,1.7-3.743l.012-3.9Z",
    transform: "translate(-925.549 -366.414)",
    fill: "#0a1e5b"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(768.716 199.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M921.192,374.634l28.03-16.289,2.487,1.436-28.03,16.289Z",
    transform: "translate(-921.192 -358.345)",
    fill: "#1a3173"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(736.05 204.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M745.4,394.926l-7.825-4.518.008-2.858,29.283,16.906c1.852,1.069,3.358.211,3.364-1.917l.011-3.9,2.487,1.436-.011,3.9c-.01,3.7-2.64,5.2-5.859,3.339L751.2,398.277",
    transform: "translate(-737.572 -387.551)",
    fill: "#0a1e5b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(735.721 171.792)"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(0 17.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(16.136 8.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M833.454,352.568c1.615.933,1.625,2.446.02,3.379a6.433,6.433,0,0,1-5.834,0c-1.615-.933-1.623-2.446-.018-3.379A6.428,6.428,0,0,1,833.454,352.568Z",
    transform: "translate(-826.423 -351.868)",
    fill: "#1a3173"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M919.172,308.986a.322.322,0,0,0-.118-.448l-8.017-4.634a4.313,4.313,0,0,1-.329.579l8.017,4.62A.322.322,0,0,0,919.172,308.986Z",
    transform: "translate(-879.578 -303.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M931.477,349.156l-5.317,3.089a.329.329,0,0,0,.33.569l5.317-3.089a.329.329,0,1,0-.33-.569Z",
    transform: "translate(-892.145 -341.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M837.328,385.293a.329.329,0,0,0,.45.12l12.371-7.187a.329.329,0,1,0-.33-.569l-12.371,7.187A.329.329,0,0,0,837.328,385.293Z",
    transform: "translate(-819.215 -364.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M875.036,376.128a.328.328,0,0,0-.45-.12l-16.54,9.609a.329.329,0,0,0,.33.569l16.54-9.609A.329.329,0,0,0,875.036,376.128Z",
    transform: "translate(-836.149 -363.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M890.63,402.866l-11.982,6.961a.329.329,0,1,0,.33.569l11.982-6.961a.329.329,0,0,0-.33-.569Z",
    transform: "translate(-853.086 -385.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M799.4,336.336l-.007,0-2.483-1.434a.329.329,0,0,0-.33,0l-6.533,3.8-8.585-4.943a.328.328,0,0,0-.448.119.337.337,0,0,0,.119.447l8.253,4.761L768.551,351.19a.4.4,0,0,0-.164.284l-.011,3.9c-.005,1.95-1.319,2.536-2.868,1.632l-28.789-16.626,17.324-10.057c-.355-.039-.724-.092-1.08-.145l-17.073,9.912a.378.378,0,0,0-.161.295l-.008,2.858a.327.327,0,0,0,.164.285l7.825,4.517a.329.329,0,0,0,.329-.569l-7.66-4.422.006-2.1,12.843,7.415,15.951,9.216c2.061,1.171,3.848.172,3.855-2.21l.01-3.328.422.243,1.4.811-.011,3.712c0,3.341-2.284,4.827-5.361,3.051l-15.655-9.038a.329.329,0,1,0-.329.569l15.654,9.038a4.487,4.487,0,0,0,4.446.42c.014-.006.029,0,.042-.012l28.025-16.294c1.2-.69,1.86-2.12,1.872-4.026l.012-3.9A.327.327,0,0,0,799.4,336.336Zm-2.655-.771,1.83,1.056L771.2,352.53l-1.829-1.056Zm2.149,4.949a3.787,3.787,0,0,1-1.544,3.46l-26.32,15.3a5.881,5.881,0,0,0,.489-2.47l.01-3.705,27.374-15.908Z",
    transform: "translate(-735.721 -325.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M825.952,355.373a6.806,6.806,0,0,0,6.161,0c1.867-1.086,1.788-2.9-.013-3.949a5.068,5.068,0,0,0-1.711-.592,3.625,3.625,0,0,1-.171.619,5.152,5.152,0,0,1,1.553.54c1.377.81,1.417,2.006.013,2.8a6.052,6.052,0,0,1-5.5,0c-1.39-.775-1.414-2.008-.013-2.8a5.072,5.072,0,0,1,1.54-.54,5.536,5.536,0,0,1-.158-.632,5.161,5.161,0,0,0-1.725.606C824.06,352.526,824.165,354.348,825.952,355.373Z",
    transform: "translate(-808.763 -342.472)",
    fill: "#fff"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(19.112 16.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M843.373,275.355v9.351a5.922,5.922,0,0,1-.292,1.837l-.5,1.519a.443.443,0,0,1-.842,0l-.5-1.519a5.924,5.924,0,0,1-.292-1.837v-9.351Z",
    transform: "translate(-840.957 -275.355)",
    fill: "#1a3173"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(11.171 10.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(0 0)",
    style: {
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(0 5.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M802.523,267.212V270.9c0,1.347-.889,2.693-2.657,3.72a14.275,14.275,0,0,1-12.945,0c-1.8-1.041-2.7-2.408-2.7-3.773V267.16c0,1.365.9,2.732,2.7,3.773a14.275,14.275,0,0,0,12.945,0C801.635,269.905,802.519,268.56,802.523,267.212Z",
    transform: "translate(-784.221 -267.16)",
    fill: "#0a1e5b"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M799.83,231.016c3.584,2.069,3.606,5.428.045,7.5a14.275,14.275,0,0,1-12.945,0c-3.584-2.069-3.6-5.428-.039-7.5A14.262,14.262,0,0,1,799.83,231.016Z",
    transform: "translate(-784.231 -229.464)",
    fill: "#1a3173"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(15.182 2.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(0 0)",
    style: {
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(0 2.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M823.161,190.765l.007,8.851a2.551,2.551,0,0,1-1.493,2.091,8.021,8.021,0,0,1-7.274,0,2.572,2.572,0,0,1-1.517-2.12l-.007-8.851a2.572,2.572,0,0,0,1.517,2.12,8.021,8.021,0,0,0,7.274,0A2.552,2.552,0,0,0,823.161,190.765Z",
    transform: "translate(-812.877 -190.736)",
    fill: "#1a3173"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M821.643,170.426c2.014,1.163,2.026,3.05.025,4.213a8.021,8.021,0,0,1-7.274,0c-2.014-1.163-2.023-3.05-.022-4.213A8.015,8.015,0,0,1,821.643,170.426Z",
    transform: "translate(-812.877 -169.554)",
    fill: "#1a3173"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(10.912 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(0)",
    style: {
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    transform: "translate(2.306 4.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M813.056,185.017v3.166a3.525,3.525,0,0,1-2.062,2.888,11.082,11.082,0,0,1-10.05,0,3.552,3.552,0,0,1-2.1-2.929v-3.166a3.552,3.552,0,0,0,2.1,2.929,11.082,11.082,0,0,0,10.05,0A3.526,3.526,0,0,0,813.056,185.017Z",
    transform: "translate(-798.849 -184.977)",
    fill: "#0a1e5b"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(2.306 0.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M810.959,156.917c2.782,1.606,2.8,4.214.035,5.82a11.082,11.082,0,0,1-10.05,0c-2.782-1.606-2.795-4.214-.03-5.82A11.072,11.072,0,0,1,810.959,156.917Z",
    transform: "translate(-798.849 -155.712)",
    fill: "#1a3173"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M801.19,169.79c0-1.518-1.008-2.934-2.831-3.986a9.767,9.767,0,0,0-1.171-.553v-.834a3.648,3.648,0,0,0,1.956-2.962v-3.168s0-.006,0-.009a3.8,3.8,0,0,0-2.227-3.145,11.369,11.369,0,0,0-10.3,0,3.772,3.772,0,0,0-2.193,3.112v3.169a3.658,3.658,0,0,0,1.968,2.99v.812a9.766,9.766,0,0,0-1.226.587c-1.793,1.042-2.782,2.442-2.787,3.944,0,0,0,0,0,0v.015l0,3.669c0,1.522,1,2.942,2.828,4a12.709,12.709,0,0,0,5.109,1.5v1.318a6.034,6.034,0,0,0,.311,1.916l.5,1.522a.695.695,0,0,0,1.326,0l.5-1.522a6.036,6.036,0,0,0,.311-1.916v-1.315a12.633,12.633,0,0,0,5.155-1.5c1.792-1.041,2.781-2.442,2.786-3.945V169.8S801.19,169.794,801.19,169.79Zm-4.518-1.855a2.314,2.314,0,0,1-1.364,1.868,7.743,7.743,0,0,1-7.015,0,2.331,2.331,0,0,1-1.387-1.9l0-3.215a11.33,11.33,0,0,0,9.766.011Zm-9.8-12.352a10.8,10.8,0,0,1,9.786,0,2.824,2.824,0,0,1,.035,5.372,10.8,10.8,0,0,1-9.791,0C784.34,159.475,784.233,157.115,786.871,155.582Zm-1.936,5.833v-1.529c.009.014.022.027.031.04a5.15,5.15,0,0,0,1.676,1.475,11.374,11.374,0,0,0,10.31,0,5.288,5.288,0,0,0,1.673-1.492v1.545a3.285,3.285,0,0,1-1.933,2.665,10.805,10.805,0,0,1-9.791,0A3.31,3.31,0,0,1,784.935,161.415Zm.485,4.836a8.841,8.841,0,0,1,.966-.458l0,2.112a2.813,2.813,0,0,0,1.646,2.345,8.315,8.315,0,0,0,7.534,0,2.8,2.8,0,0,0,1.622-2.315l0-2.114a8.789,8.789,0,0,1,.912.43c1.657.957,2.57,2.213,2.572,3.539,0,1.515-1.189,2.731-2.528,3.509a14,14,0,0,1-12.686,0c-1.342-.775-2.567-1.98-2.569-3.536C782.888,168.449,783.786,167.2,785.42,166.252Zm7.31,14a5.636,5.636,0,0,1-.28,1.761l-.5,1.512a.183.183,0,0,1-.352,0l-.5-1.512a5.642,5.642,0,0,1-.28-1.761v-1.289c.328.02.655.054.984.054.309,0,.614-.033.921-.051Zm7.942-8.615v1.853c0,1.311-.9,2.553-2.528,3.5a14,14,0,0,1-12.686,0c-1.66-.959-2.573-2.219-2.569-3.549V171.6a6.491,6.491,0,0,0,2.312,2.149,13.513,13.513,0,0,0,6.61,1.582c.51,0,1.018-.037,1.522-.085a12.585,12.585,0,0,0,5.072-1.5A6.419,6.419,0,0,0,800.672,171.633Z",
    transform: "translate(-782.37 -153.9)",
    fill: "#fff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecSheets);
export default __webpack_public_path__ + "static/media/spec-sheets.a0e521ae205dd6691d1e6dbbef20aeb1.svg";
export { ForwardRef as ReactComponent };